"use client";

import { ReactNode } from "react";
import { createPortal } from "react-dom";
import * as s from "@/lib/styles";
import { useEscapeToClose } from "@/lib/use-escape-to-close";

/**
 * A dialog modal: dimmed overlay + centered panel, rendered through a portal so
 * it works from anywhere (including table rows). Escape closes the topmost
 * modal and clicking the overlay closes this one — both gated by `dismissable`
 * (pass `false` while a save is in flight to keep it open).
 */
export function Modal({
  onClose,
  children,
  dismissable = true,
}: {
  onClose: () => void;
  children: ReactNode;
  dismissable?: boolean;
}) {
  useEscapeToClose(() => { if (dismissable) onClose(); });

  if (typeof document === "undefined") return null;

  return createPortal(
    <div className={s.modalOverlay} onClick={() => { if (dismissable) onClose(); }}>
      <div className={s.modalContent} onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.body,
  );
}
